import React,{useEffect,useState} from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import BodyText from './BodyText';
import DashboardTable from './DashboardTable';
import { useSelector,useDispatch } from 'react-redux';
import TitleText from './TitleText';
import FlightModalDetail from './FlightModalDetail';
import { agentbookinghistoryDispatch } from '../../reducers/UserReducer';
const tableHeaders = [
	'ORDER_ID',
	'Depart From',
	'Journey To',
	'Date of Booking',
	'Journey Date',
	'Ticket Cost',
	'Status',
	'Action',
];

const StyledTableCell = withStyles((theme) => ({
	head: {
		fontWeight: 600,

		// padding: 3,
		fontSize: 12,
		textTransform: 'uppercase',
		background: 'aliceblue',
	},
	root: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
}))(TableCell);
const BookingHistory = () => {
	const dispatch = useDispatch()
	const [val,setVal] = useState('')
	const { bookinghistory, bookinghistoryagent,agentlogin } = useSelector(
		(state) => state.user
	);
	useEffect(() => {
		
		dispatch(agentbookinghistoryDispatch(agentlogin && agentlogin.result.result.id));
	  }, []);
	  const [data, setData] = useState('');
	console.log("Booking",bookinghistoryagent)
	const handleSearch = (event) => {
		let value = event.target.value.toLowerCase();
		let results = [];
		console.log(value);
		setVal(value);

		results =
		bookinghistoryagent &&
		bookinghistoryagent.result &&
		bookinghistoryagent.result.flights.filter(
			item => {
			  return (
				item
				.orderId
				.toLowerCase()
				.includes(value.toLowerCase()) ||
				item
				.userEmail
				.toLowerCase()
				.includes(value.toLowerCase())||
				item
				.origin
				.toLowerCase()
				.includes(value.toLowerCase())||
				item
				.destination
				.toLowerCase()
				.includes(value.toLowerCase())||
				item
				.flightType
				.toLowerCase()
				.includes(value.toLowerCase())
				||
				item
				.journeyType
				.toLowerCase()
				.includes(value.toLowerCase())||
				item
				.journeyType
				.toLowerCase()
				.includes(value.toLowerCase())||
				item
				.supplier
				.toLowerCase()
				.includes(value.toLowerCase())||
				item
				.bookingStatus
				.toLowerCase()
				.includes(value.toLowerCase())||
				item
				.travelDate
				.toLowerCase()
				.includes(value.toLowerCase())
			  );
			}
		  );
		setData(results);
		// console.log(results);
	};
	console.log("Result",data);
	// const handleSearch =
	
	return (
		<>
		<Box style={{alignItems:'center',justifyContent:'space-between',display:'flex'}}>
					<h2 style={{ fontFamily: 'Josefin Sans, sans-serif' }}>
						Booking History
					</h2>
					<Box>

					<i class="fa fa-search icon" style={{background: 'white',
    padding: '14px'}}> </i>
					<input
              type="search"
			  style={{padding: '13px',
			}}
				placeholder='Search'
              value={val}
              onChange={handleSearch}
            //   className="form-control form-control-sm"
            />
					</Box>
					
				</Box>
			<Grid container spacing={2}>
				
				<Grid item xs={12}>
					<TableContainer style={{ marginTop: 15 }}>
						<Table>
							<TableHead>
								<TableRow>
									{tableHeaders.map((title, index) => (
										<StyledTableCell key={title}>{title}</StyledTableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody style={{ marginTop: 20 }}>
								{bookinghistory
									? bookinghistory &&
									  bookinghistory.result &&
									  bookinghistory.result.flights.length > 0 &&
									  bookinghistory.result.flights.map((item, index) => {
											return <DashboardTable item={item} rowIndex={index} />;
									  })
									: data?data.length > 0 &&
									data.map((item, index) => {
										  return <DashboardTable item={item} rowIndex={index} />;
									})
								  : bookinghistoryagent
									? bookinghistoryagent &&
									  bookinghistoryagent.result &&
									  bookinghistoryagent.result.flights.length > 0 &&
									  bookinghistoryagent.result.flights.map((item, index) => {
											return <DashboardTable item={item} rowIndex={index} />;
									  })
									: ''}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
			<FlightModalDetail />
		</>
	);
};

export default BookingHistory;
